import type { ITierReport } from '@/types/Data'
import type { IGetTierReport } from '@/types/Request'
import BaseService from '../BaseService'

export default class TierReportServices extends BaseService {
  GetTopTierReportByContent(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_CONTENT, data)
  }
  GetTopTierReportByDays(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_DAYS, data)
  }
  GetTopTierReportByHours(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_HOURS, data)
  }
  GetTopTierReportByPerson(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_PERSON, data)
  }
  GetTopTierReportByDepartment(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_DEPARTMENT, data)
  }
  GetTopTierReportByLocation(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_LOCATION, data)
  }
  GetTopTierReportByCategory(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_CATEGORY, data)
  }
  GetTopTierReportByCity(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_CITY, data)
  }
  GetTopTierReportByEmployeeWorkerType(data: IGetTierReport) {
    return this.POST<ITierReport>(this.PATHS.GET_TOP_TIER_REPORT_BY_EMPLOYEE_WORKER_TYPE, data)
  }

  GetTopTierReportByContentExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_CONTENT_EXCEL, true, data)
  }
  GetTopTierReportByDaysExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_DAYS_EXCEL, true, data)
  }
  GetTopTierReportByHoursExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_HOURS_EXCEL, true, data)
  }
  GetTopTierReportByPersonExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_PERSON_EXCEL, true, data)
  }
  GetTopTierReportByDepartmentExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_DEPARTMENT_EXCEL, true, data)
  }
  GetTopTierReportByLocationExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_LOCATION_EXCEL, true, data)
  }
  GetTopTierReportByCategoryExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_CATEGORY_EXCEL, true, data)
  }
  GetTopTierReportByCityExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_CITY_EXCEL, true, data)
  }
  GetTopTierReportByEmployeeWorkerTypeExcel(data: IGetTierReport) {
    return this.EXCEL(this.PATHS.GET_TOP_TIER_REPORT_BY_EMPLOYEE_WORKER_TYPE_EXCEL, true, data)
  }
}
